var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeviceRide = function SvgDeviceRide(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg10",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    strokeWidth: 1.227,
    d: "M9.98 19.799c5.425 0 9.82-4.394 9.82-9.819S15.404.161 9.98.161.161 4.555.161 9.981s4.394 9.818 9.82 9.818m0-17.183c4.063 0 7.364 3.302 7.364 7.364s-3.301 7.364-7.364 7.364-7.364-3.301-7.364-7.364S5.918 2.616 9.98 2.616"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g6",
    transform: "translate(-4.748 -4.75)scale(1.2274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M11.425 19.967c-1.933-.177-3.591-.916-4.927-2.194-2.26-2.164-3.049-5.346-2.06-8.317.976-2.937 3.612-5.053 6.717-5.395a10 10 0 0 1 1.7.002 7.99 7.99 0 0 1 5.177 2.713 7.97 7.97 0 0 1-.503 10.97 7.4 7.4 0 0 1-2.023 1.417 7.9 7.9 0 0 1-2.355.737c-.373.056-1.412.096-1.726.067z",
    opacity: 0.99
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path8",
    fill: "#fff",
    strokeWidth: 1.227,
    d: "m15.184 9.396-8.118-4.99a.736.736 0 0 0-1.119.627v9.933c0 .265.144.51.372.64q.168.093.357.094a.74.74 0 0 0 .38-.107l8.119-4.948a.73.73 0 0 0 .352-.622.7.7 0 0 0-.343-.627"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeviceRide);
export default ForwardRef;